import { render } from "./PortalSnackBar.vue?vue&type=template&id=533ae2fb&scoped=true"
import script from "./PortalSnackBar.vue?vue&type=script&lang=js"
export * from "./PortalSnackBar.vue?vue&type=script&lang=js"

import "./PortalSnackBar.vue?vue&type=style&index=0&id=533ae2fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533ae2fb"]])

export default __exports__